import type { Context } from '~/prix'
import { auth } from '~/utils/client/auth'

type TokenContext = Pick<Context, 'bypassAuth' | 'getToken' | 'token'>

export default async function resolveCurrentRequestToken(
  context: TokenContext,
): Promise<string | null> {
  if (context.bypassAuth) {
    return context.token
  }

  if (!auth.currentUser) {
    return context.token
  }

  try {
    return await context.getToken()
  } catch (error) {
    console.error('[resolveCurrentRequestToken] Erro ao obter token atualizado', error)
    return context.token
  }
}
